// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateDealerTransferHistoryCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_DEALER_TRANSFER_HISTORY_CRITERIA,
    value
});

export const resetDealerTransferHistoryCriteria = () => ({

    type: actions.RESET_DEALER_TRANSFER_HISTORY_CRITERIA

});



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/action-creators/criteria.js